import NextImage from "next/image";
import React from "react";

import { verticalProductCardImageVariants } from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  altOverride?: string;
  product: Pick<ProductCardDataType, "image" | "brandName">;
  onClick?: () => void;
};

// Helper function to replace getStaticFile
const getPlaceholderImage = () => "/images/placeholder.svg";

export const BP_PRODUCT_CARD_IMAGE_QUALITY = 85;

export const VerticalProductCardImage: React.FC<Props> = ({
  altOverride,
  product,
  onClick
}) => {
  const handleClick = onClick
    ? (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }
    : undefined;

  const propOverrides = {
    height: undefined as number | undefined,
    width: undefined as number | undefined,
    style: {},
    sizes: ""
  };

  // Since we're always using this for product cards without explicit dimensions
  propOverrides.height = 40;
  propOverrides.width = 40;

  // Product cards are always square variant
  propOverrides.style = {
    height: "100%",
    width: "100%",
    objectFit: "cover" as const
  };

  propOverrides.sizes =
    "(max-width: 374px) 100vw, (max-width: 768px) 50vw, (max-width: 1440px) 33vw, 20vw";

  return (
    <div
      className={verticalProductCardImageVariants.square}
      onClick={handleClick}
    >
      <NextImage
        src={product.image.src || getPlaceholderImage()}
        alt={altOverride ?? product.image.alt ?? product.brandName ?? ""}
        placeholder="blur"
        blurDataURL={getPlaceholderImage()}
        {...propOverrides}
        quality={BP_PRODUCT_CARD_IMAGE_QUALITY}
      />
    </div>
  );
};
